const accountDomain = process.env.VUE_APP_ACCOUNT_URL;
const forgotPasswordUrl = `${accountDomain}/forgot-password`;

export default {
  accountDomain,
  forgotPasswordUrl,
};
